import { render, staticRenderFns } from "./ArticleSeven.vue?vue&type=template&id=0ca9b2be&scoped=true"
import script from "./ArticleSeven.vue?vue&type=script&lang=js"
export * from "./ArticleSeven.vue?vue&type=script&lang=js"
import style0 from "./ArticleSeven.vue?vue&type=style&index=0&id=0ca9b2be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca9b2be",
  null
  
)

export default component.exports